import React from 'react'
import PropTypes from 'prop-types';
// import Link from 'next/link';
import AppCustomLink from './AppCustomLink';

// const subDomain = ''; // '/app';

export default function ProfilePageRoute({ children, profileUID }) {
    return (
        <>
            <AppCustomLink href={`/profile?id=${profileUID}`} as={`/profile/${profileUID}`}><span style={{ cursor: 'pointer' }}>{children}</span></AppCustomLink>
        </>
    )
}

ProfilePageRoute.propTypes = {
    children: PropTypes.any,
    profileUID: PropTypes.any,
}
